export default __webpack_public_path__ + "static/media/cash.70d9fafc.mp3";